const updateShowModalFlag = (_, variables, { cache }) => {
  const { showModal } = variables;
  const data = {
    configurator: {
      __typename: 'Configurator',
      globals: {
        __typename: 'Globals',
        showModal
      }
    }
  };
  cache.writeData({ data });
  return null;
};

export default updateShowModalFlag;
